/**
 * Created by Jew on 7/24/2017.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { Router } from '@angular/router';
import { Toast } from 'app/shared/toast/toast';
import { AdminApi } from '../admin-api';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'app-update-quota',
   templateUrl: './update-quota.component.html',
   styleUrls: ['./update-quota.component.css']
})
export class UpdateQuotaComponent implements OnInit {
   tin: string;
   usernames: string[];
   username: string;
   quota: any;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
      public dialogRef: MatDialogRef<UpdateQuotaComponent>,
      private api: AdminApi, private translate: TranslateService,
      public service: IdexService, private router: Router, private toast: Toast, public dialog: MatDialog) {
      this.usernames = data.users.map(m => m.id);
      if(this.usernames.length === 1){
         this.username = this.usernames[0];
         this.api.getQuota(this.username).subscribe(result => {
            if(result){
               this.quota = result;
            }
         })
      }
   }
   ngOnInit() {
      this.tin = window.localStorage.getItem('tin');
   }

   async updateQuota() {
      let count = 0;
      for(let uname of this.usernames){
         await this.api.updateQuota(uname,this.quota)
         ++count;
      }
      this.translate.get('business.update_quota_success').subscribe(s => {
         this.toast.success(s.toString())
      })
      this.dialogRef.close();
   }
   

   isEmpty(): boolean {
      const pattern = /^-1$|^[0-9]+$/;
      return this.quota === null || this.quota === undefined || this.quota === '' || this.quota === '0'
         || !pattern.test(this.quota);
   }

   keyPress(event: any) {
      const pattern = /[\-0-9]/;
  
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
}